import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "n-icon" }
const _hoisted_2 = { viewBox: "0 0 24 24" }
const _hoisted_3 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-add-icon',
},
  __name: 'add-icon',
  props: {
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("path", {
        fill: __props.fill,
        d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
      }, null, 8, _hoisted_3)
    ]))
  ]))
}
}

})